import { useQuery } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';
import { unique } from 'utils/array';
import { promiseAllBatched } from 'utils/promise';

const GetExpandedParentTreeItemsBatchSize = 4;

/**
 * Returns the parent ids that should be expanded for a set of selected tree items.
 */
export const getExpandedParentTreeItems = async (selectedTreeItemIds: string[]) => {
    const selectedTreeItems = await promiseAllBatched(
        selectedTreeItemIds.map((id) => () => sdClient.getTreeItem({ treeItemId: id })),
        GetExpandedParentTreeItemsBatchSize,
    );
    return unique(
        selectedTreeItems.flatMap((treeItem) =>
            treeItem.Hierarchy.map((child) => child.HierarchyId),
        ),
    );
};

export function useInitialTreeExpansion(selectedTreeItemIds: string[]) {
    return useQuery({
        queryKey: ['initial tree expansion', selectedTreeItemIds],

        queryFn: () => getExpandedParentTreeItems(selectedTreeItemIds),
    });
}
